import { track } from '@tldraw/tldraw'
import { Marker2 } from 'blaze-ui/icons/20/Marker2'
import { observer } from 'mobx-react-lite'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './ColorsPanel.module.scss'
import { Color, GradientColor, SolidColor } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { Fragment } from 'react'
import { GradientStopSlider } from './GradientStopSlider'
import { AddGradientStopButton } from './AddGradientStopButton'
import { GradientStopEditor } from './GradientStopEditor'

interface Props {
  selectedColor: GradientColor
  onNewColorChange: (color: Color) => void
  documentSolidColors: SolidColor[]
}

export const GradientStopsEditor = track(
  observer(({ selectedColor, onNewColorChange, documentSolidColors }: Props) => {
    const handleSliderChange = (values: number | number[]) => {
      const newColor = {
        ...selectedColor,
        stops: selectedColor.stops.map((stop, index) => ({
          ...stop,
          position: Array.isArray(values) ? values[index] : values,
        })),
      }

      onNewColorChange(newColor)
    }

    return (
      <div className={Styles.gradientStopsEditor}>
        <div className={Styles.gradientStopsEditorHeading}>
          <div className={Styles.headerWithIcon}>
            <Marker2 color="#0FABB6" />
            <Text variant="smallList">Gradient Stops</Text>
          </div>
          <AddGradientStopButton selectedColor={selectedColor} onNewColorChange={onNewColorChange} />
        </div>
        <div className={Styles.gradientPreviewContainer}>
          <div
            className={Styles.gradientPreview}
            style={{
              background: `linear-gradient(90deg, ${selectedColor.stops
                .map((s) => `color-mix(in srgb, ${s.color} ${s.opacity * 100}%, transparent) ${s.position * 100}%`)
                .join(', ')})`,
            }}
          />
        </div>
        <GradientStopSlider
          key={`stop-${selectedColor.stops.length}`}
          stops={selectedColor.stops}
          onChange={handleSliderChange}
          value={selectedColor.stops.map((s) => s.position)}
          maxValue={1}
          step={0.01}
        />
        <div className={Styles.gradientStopEditorsContainer}>
          {selectedColor.stops.map((stop, index) => (
            <Fragment key={index}>
              <div className={Styles.gradientEditorDivider} />
              <GradientStopEditor
                selectedColor={selectedColor}
                stop={stop}
                minPosition={index === 0 ? 0 : (selectedColor.stops[index - 1].position + 0.01) * 100}
                maxPosition={
                  index === selectedColor.stops.length - 1
                    ? 100
                    : (selectedColor.stops[index + 1].position - 0.01) * 100
                }
                documentSolidColors={documentSolidColors}
                onNewColorChange={onNewColorChange}
              />
            </Fragment>
          ))}
        </div>
      </div>
    )
  }),
)
